module.exports = __webpack_public_path__ + "static/media/slideshow-splitter.49319da4.svg";